import schoolquotaApi from './api/schoolquotaApi';

export const SCHOOLQUOTA_INSERT = 'schoolquota/INSERT';
export const SCHOOLQUOTA_LIST = 'schoolquota/LIST';

const initialState = {
	data: null,
}

export default (state = initialState, action) => {
	switch (action.type) {
		case SCHOOLQUOTA_LIST:
			return {
				...state,
				data: action.payload
			};
		default:
			return state;
		
	}
};

export const schoolquotaInsert = (payload) => {
	return dispatch => {
		return schoolquotaApi.SchoolQuotaInsert(payload).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const schoolquotaUpdate = (payload, id) => {
	return dispatch => {
		return schoolquotaApi.SchoolQuotaUpdate(payload, id).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const schoolquotaList = () => {
	return dispatch => {
		return schoolquotaApi.SchoolQuotaList().then(data => {
			dispatch({
				type: SCHOOLQUOTA_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const schoolquotaDelete = (id) => {
	return dispatch => {
		return schoolquotaApi.SchoolQuotaDelete(id).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};